<template>
	<v-container ref="fullPage" :style="darkTheme ? 'background-color: black;' : 'background-color: white;'" 
		fluid class="fullpage">
 	<v-layout column >
		<v-toolbar height="80">           
			<v-flex class = "ml-3">
				<v-toolbar-title class="ml-5 topTitle"> 
					<v-layout align-center row fill-height>     
						<img src="@/images/ua_block_rgb_3.3c82a4c.png" class="blocka">
						<a href="/bldgviewer" 
							style="text-decoration: none;"
							:style="darkTheme ? 'color: whitesmoke;' : 'color: black;'"> 
								Space Summary 
						</a>						
					</v-layout>
				</v-toolbar-title>  
			</v-flex>
				<v-btn large icon class="grey--text text--darken-2" 
					@click="">
					<v-icon large >close</v-icon>
				</v-btn>
		</v-toolbar>	
        <v-progress-linear v-if="loading" class="mt-0" color="blue" indeterminate></v-progress-linear>
		
        <v-container grid-list-md text-xs-center>
    		<v-layout row wrap v-if="spaceSummary">
				<v-flex xs3>
					<v-card class="pa-5 title">				
						<v-flex>BUILDINGS</v-flex>
						<v-flex>{{spaceSummary.buildings.toLocaleString(undefined, { maximumFractionDigits: 0 })}}</v-flex>
					</v-card>
				</v-flex>
				<v-flex xs3>
					<v-card class="pa-5 title">				
						<v-flex>FLOORS</v-flex>
						<v-flex>{{nFormatter(spaceSummary.floors, 1)}}</v-flex>
					</v-card>
				</v-flex>
				<v-flex xs3>
					<v-card class="pa-5 title">				
						<v-flex>ROOMS</v-flex>
						<v-flex>{{nFormatter(spaceSummary.rooms, 1)}}</v-flex>
					</v-card>
				</v-flex>
				<v-flex xs3>
					<v-card class="pa-5 title">				
						<v-flex>TOTAL GSF</v-flex>
						<v-flex>{{nFormatter(spaceSummary.totalGSF, 1)}}</v-flex>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container>
			<v-layout class="mt-5" v-if="roomCategorySummary">
				
				<v-flex class="title mr-5">
					<v-card class="py-4">
						<canvas id="categoryBarChart2" width="200" height="80"></canvas>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
				<v-container>
			<v-layout class="mt-5" v-if="roomCategorySummary">
				<v-flex class="title mr-5">
					<v-card class="py-4">
						<canvas id="collegeBarChart2" width="200" height="80"></canvas>
					</v-card>
				</v-flex>
			</v-layout>
		</v-container>
		<v-container text-xs-center>
			<v-layout class="mt-5">
				<v-flex xs4 class="title mr-5">
					<v-card class="py-4">
						<div class="pb-3">CATEGORIES</div>
					<v-layout style="height: 500px; overflow-y: scroll;" v-if="roomCategorySummary">
						<v-flex id="categoryBarChart" class="pr-3"></v-flex>
					</v-layout></v-card>
				</v-flex>
				<v-flex xs4 class="title mr-5">
					<v-card class="py-4">
						<div class="pb-3">COLLEGES</div>
					<v-layout style="height: 500px; overflow-y: scroll;" v-if="collegeSummary">
						<v-flex id="collegeBarChart" class="pr-3"></v-flex>
					</v-layout></v-card>
				</v-flex>
			</v-layout>			
		</v-container>
	</v-layout> 
</v-container>
</template>

<script>
import Vue from 'vue'
import { GChart } from 'vue-google-charts'
import { mapState, mapMutations, mapActions } from 'vuex'

import Chart from 'chart.js'

export default {

	computed: {
		loading() { //If we haven't loaded all our data sets, show loading bar
			if (!collegeSummary || !roomClassificationSummary || !roomCategorySummary || !spaceSummary || !roomUseSummary) {
				return true
			}
			else {
				return false
			}
		}
	},

data () {
	return {
		loading: true,
		colleges: [],
		collegeData: [],

		categoryBarChartChartsJSData: {
		  	labels: [],
		  	datasets: [{ label: 'Categories', data: [], }]
		},

		collegeBarChartChartsJSData: {
		  	labels: [],
		  	datasets: [{ label: 'Colleges', data: [], }]
		},
		
		/*categoryBarChartChartsJSData: {
		  labels: ['1', '2', '3', '4', '5', '6', '7'],
		  datasets: [{
		    axis: 'y',
		    label: 'My First Dataset',
		    data: [65, 59, 80, 81, 56, 55, 40],
		    fill: false,
		    backgroundColor: [
		      'rgba(255, 99, 132, 0.2)',
		      'rgba(255, 159, 64, 0.2)',
		      'rgba(255, 205, 86, 0.2)',
		      'rgba(75, 192, 192, 0.2)',
		      'rgba(54, 162, 235, 0.2)',
		      'rgba(153, 102, 255, 0.2)',
		      'rgba(201, 203, 207, 0.2)'
		    ],
		    borderColor: [
		      'rgb(255, 99, 132)',
		      'rgb(255, 159, 64)',
		      'rgb(255, 205, 86)',
		      'rgb(75, 192, 192)',
		      'rgb(54, 162, 235)',
		      'rgb(153, 102, 255)',
		      'rgb(201, 203, 207)'
		    ],
		    borderWidth: 1
		  }]
		},*/

		categoryBarChart2ChartsJSConfig: {
			type: 'horizontalBar',
			data: this.categoryBarChartChartsJSData,
			options: {
				 	scales: {
						yAxes: [{ticks: {mirror: true}}]
					},
			},
		},

		categoryOptions: {
          	series: [{ name: 'Category', data: [] }],
          	chart: { type: 'bar', height: 3050 },
        	plotOptions: { bar: { borderRadius: 4, horizontal: true, } },
        	dataLabels: { enabled: false },
        	xaxis: { categories: [], },
        	theme: { monochrome: { enabled: true, color: '#000090', shadeTo: 'light', shadeIntensity: 0.95 }},
        	fill: {
			  type: 'gradient',
			  gradient: {
			    shade: 'dark',
			    type: "horizontal",
			    shadeIntensity: 0.9,
			    gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
			    inverseColors: true,
			    opacityFrom: 1,
			    opacityTo: 1,
			    stops: [0, 50, 100],
			    colorStops: []
				},
			},
        },

        collegeOptions: {
          	series: [{ name: 'College', data: [] }],
          	chart: { type: 'bar', height: 3050 },
        	plotOptions: { bar: { borderRadius: 4, horizontal: true, } },
        	dataLabels: { enabled: false },
        	xaxis: { categories: [], },
        	theme: { monochrome: { enabled: true, color: '#000090', shadeTo: 'light', shadeIntensity: 0.95 }},
        	fill: {
			  type: 'gradient',
			  gradient: {
			    shade: 'dark',
			    type: "horizontal",
			    shadeIntensity: 0.9,
			    gradientToColors: undefined, // optional, if not defined - uses the shades of same color in series
			    inverseColors: true,
			    opacityFrom: 1,
			    opacityTo: 1,
			    stops: [0, 50, 100],
			    colorStops: []
				},
			},
			
        },
	}
},

components: { GChart },

mounted: async function () {
	 this.fetchSpaceSummary()
	 this.fetchRoomUseSummary()
	 this.fetchRoomCategorySummary().then(() => {
		// Chart.JS Category Bar Chart    
			let categoryData2 = [...this.roomCategorySummary] // copy so it can be sorted seperately
			categoryData2.sort((a,b) => (b.area - a.area) )
			categoryData2.forEach((category) => {
				if (category.area > 0 && category.name != "Circulation Area" && this.categoryBarChartChartsJSData.labels.length < 11) {
					this.categoryBarChartChartsJSData.labels.push(category.name + " (" + category.area.toLocaleString() + ")")
					this.categoryBarChartChartsJSData.datasets[0].data.push(category.area)
				}
			})
			let categoryBarChart2 = new Chart(document.querySelector("#categoryBarChart2"), this.categoryBarChart2ChartsJSConfig)
			categoryBarChart2.data = this.categoryBarChartChartsJSData
			categoryBarChart2.update()
			console.log(this.categoryBarChart2ChartsJSConfig)

			// Category Bar Chart
			let categoryData = [...this.roomCategorySummary] // copy so it can be sorted seperately
			categoryData.sort((a,b) => (b.area - a.area) )
			categoryData.forEach((category) => {
				if (category.area > 0) {
					this.categoryOptions.xaxis.categories.push(category.name)
					this.categoryOptions.series[0].data.push(category.area)
				}
			})

		
	 })
	 this.fetchRoomClassificationSummary()
	 this.fetchCollegeSummary().then(() => {
			// College Bar Chart
			let collegeData = [...this.collegeSummary] // copy so it can be sorted seperately
			collegeData.sort((a,b) => (b.area - a.area) )
			collegeData.forEach((college) => {
				if (college.area > 0) {
					this.collegeOptions.xaxis.categories.push(college.name)
					this.collegeOptions.series[0].data.push(college.area)
				}
			})

		
			// College Bar Chart 3 (1-17-23)
			let collegeData2 = [...this.collegeSummary] // copy so it can be sorted seperately
			collegeData2.sort((a,b) => (b.area - a.area) )
			collegeData2.forEach((college) => {
				if (college.area > 0 && this.collegeBarChartChartsJSData.labels.length < 22) {
					this.collegeBarChartChartsJSData.labels.push(college.name + " (" + college.area.toLocaleString() + ")")
					this.collegeBarChartChartsJSData.datasets[0].data.push(college.area)
				}
			})
			let collegeBarChart2 = new Chart(document.querySelector("#collegeBarChart2"), this.categoryBarChart2ChartsJSConfig)
			collegeBarChart2.data = this.collegeBarChartChartsJSData
			collegeBarChart2.update()

			

			//This is the longest fetch. Set loading to false when done
			this.loading = false
	})
	
	//this.setSpaceSummary(this.staticData)

    //let planetChart = new Chart(document.querySelector("#planet-chart"), this.planetChartData);
	
},

computed: {
	...mapState({   	darkTheme: 					state => state.ui.darkTheme,
						spaceSummary: 				state => state.space.spaceSummary,
						roomUseSummary: 			state => state.space.roomUseSummary,
						roomCategorySummary: 		state => state.space.roomCategorySummary,
						roomClassificationSummary: 	state => state.space.roomClassificationSummary,
						collegeSummary: 			state => state.space.collegeSummary,
				}),
},



methods: {
	...mapActions(['fetchSpaceSummary', 'fetchRoomUseSummary', 'fetchRoomCategorySummary', 'fetchRoomClassificationSummary', 'fetchCollegeSummary']),
	...mapMutations(['setSpaceSummary']),

	nFormatter(num, digits) {
	  const lookup = [
	    { value: 1, symbol: "" },
	    { value: 1e3, symbol: "k" },
	    { value: 1e6, symbol: "M" },
	    { value: 1e9, symbol: "G" },
	    { value: 1e12, symbol: "T" },
	    { value: 1e15, symbol: "P" },
	    { value: 1e18, symbol: "E" }
	  ];
	  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
	  var item = lookup.slice().reverse().find(function(item) {
	    return num >= item.value;
	  });
	  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
	},


}

}
</script>

<style scoped>
.fullpage {
	display: absolute;
	flex-direction: column;
	flex: 1;
	z-index: 10;
	position: fixed;
	top: 0px;
	width: 100vw;
	background-color: rgba(255, 255, 255, 1);
	padding: 0px !important;
	margin-top: 0px;
	height: 100%;
	overflow: auto;
}

   ::-webkit-scrollbar {
    width: 6px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
    background: #dde5ed;
  }

  /* Handle */
  ::-webkit-scrollbar-thumb {
    background: #000090;
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
    background: #555;
  }

</style>


// WEBPACK FOOTER //
// src/components/SummaryDashboard.vue